import React from 'react';
import { isArray, get, has, filter } from 'lodash';
import { Link } from 'react-router-dom';

import styles from './indexPageListAreaStyles';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import { IndexAreaLoadingSpinner } from 'buyside/components/presentation/IndexPage/IndexPage';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

import StarIcon from 'SVGs/star';
import BriefcaseIcon from 'SVGs/briefcase';

export const BackToAllButton = () => (
  <Link to="/">
    <Button
      text="Back to All"
      type={BUTTON_TYPES.LINK}
      className={styles.showOnlyRecommendedFundsButton}
      icon={BriefcaseIcon}
    />
  </Link>
);

export const RecommendedOnlyButton = ({ additionalParams = '' }) => (
  <Link to={{ search: `?recommended=true${additionalParams}` }}>
    <Button
      text="Show Recommended Only"
      type={BUTTON_TYPES.LINK}
      className={styles.showOnlyRecommendedFundsButton}
      icon={StarIcon}
    />
  </Link>
);

const IndexPageListArea = props => {
  const {
    loading,
    data,
    currentUser,
    card,
    loadingCard,
    recommendations,
    recommendationComponent,
    showOnlyRecommended,
    isMobile
  } = props;

  const LoadingCard = loadingCard;
  const IndexCard = card;
  const RecommendationCard = recommendationComponent;
  const currentUserAdminFundCount = get(currentUser, 'adminFundProfiles.length', 0);
  const renderRecommendedLink = () => (
    <div>
      {showOnlyRecommended ? (
        <BackToAllButton />
      ) : (
        <>
          {currentUserAdminFundCount > 1 ? null : (
            <RecommendedOnlyButton
              additionalParams={
                currentUserAdminFundCount === 1
                  ? `&fpid=${currentUser.adminFundProfiles[0].id}`
                  : ''
              }
            />
          )}
        </>
      )}
    </div>
  );

  const hasRecommendations = Boolean(
    has(recommendations, 'edges.length') && recommendations.edges.length
  );

  let recommendationIds = [];
  if (hasRecommendations) {
    recommendationIds = recommendations.edges.map(edge => {
      if (edge.node.fundProfile) {
        return edge.node.fundProfile.id;
      } else if (edge.node.allocatorProfile) {
        return edge.node.allocatorProfile.id;
      } else {
        return null;
      }
    });
  }

  const { canAccessMessages, canManageMessages, canViewUserDetails, isAdmin, isAllocator } =
    currentUser || {};

  return (
    <div className={styles.indexAreaContainer}>
      <IndexAreaLoadingSpinner loading={loading} data={data}>
        {loading && !(data || currentUser) && (
          <>
            {LoadingCard ? (
              <>
                {[0, 1, 2, 3, 4].map(i => (
                  <div className={styles.ideaIndexCardArea} key={i}>
                    <LoadingCard />
                  </div>
                ))}
              </>
            ) : (
              <div className={styles.loadingSpinner}>
                <LoadingSpinner size="medium" />
              </div>
            )}
          </>
        )}
        {!showOnlyRecommended &&
          !loading &&
          (!data || !get(data, 'edges.length', -1) || (isArray(data) && !data.length)) && (
            <p>No results found. Please try again with a different set of search criteria.</p>
          )}
        <section className={styles.cardListSection}>
          {hasRecommendations && renderRecommendedLink()}
          {hasRecommendations &&
            recommendationComponent &&
            filter(recommendations.edges, edge => !edge.node.hide).length > 0 && (
              <div>
                {recommendations.edges.map((edge, idx) => {
                  if (edge.node.hide) return null;
                  return (
                    <div className={styles.ideaIndexCardArea} key={idx}>
                      <RecommendationCard node={edge.node} isFirst={idx === 0} card={card} />
                    </div>
                  );
                })}
              </div>
            )}
          {!showOnlyRecommended && get(data, 'edges.length', 0) > 0
            ? data.edges.map(edge => {
                if (recommendationIds.indexOf(edge.node.id) > -1) {
                  return null;
                }
                return (
                  <div className={styles.ideaIndexCardArea} key={edge.node.id}>
                    <IndexCard
                      canViewUserDetails={canViewUserDetails}
                      currentUser={currentUser}
                      isAdmin={isAdmin}
                      isAllocator={isAllocator}
                      isMobile={isMobile}
                      node={edge.node}
                    />
                  </div>
                );
              })
            : !showOnlyRecommended &&
              get(data, 'length', 0) > 0 &&
              data.map(node => {
                if (recommendationIds.indexOf(node.id) > -1) {
                  return null;
                }
                return (
                  <div className={styles.ideaIndexCardArea} key={node.id}>
                    <IndexCard
                      canAccessMessages={canAccessMessages}
                      canManageMessages={canManageMessages}
                      canViewUserDetails={canViewUserDetails}
                      currentUser={currentUser}
                      isAdmin={isAdmin}
                      isAllocator={isAllocator}
                      isMobile={isMobile}
                      node={node}
                    />
                  </div>
                );
              })}
          {showOnlyRecommended &&
            get(recommendations, 'edges.length', -1) < 1 &&
            renderRecommendedLink()}
        </section>
      </IndexAreaLoadingSpinner>
    </div>
  );
};

export default IndexPageListArea;
